module.exports = __webpack_public_path__ + "img/RECEIVE_MONEY.1563c49a.svg";